module.exports = __webpack_public_path__ + "static/img/kontakt.80185e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kontakt/kontakt.png
// module id = Rinm
// module chunks = 0